import {
  Box,
  Button,
  Dialog,
  Grid,
  InputAdornment,
  TextField,
  Typography,
  useMediaQuery,
  Stack,
  IconButton,
  Tooltip,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import { poppins400, poppins500 } from 'theme/common.style';
import { Pendingwarning } from 'component/BuyersMarketplace/Marketplaceicons';
import { useContext, useEffect, useState, useRef, useCallback } from 'react';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import {
  getApiCall,
  Moxoseparationinlisting,
  postApiCall,
  formatDepositDate,
} from 'api/apiService';
import Swal from 'sweetalert2';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { DEPOSIT_MANAGER_DETAILS, REQUEST_DEPOSIT } from 'constant/app.config';
import dayjs from 'dayjs';
import { Calendarimg } from 'component/OwnerCard/NotesTasks';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import Loading from 'assets/images/loading.png';
import AgencyBadge from 'component/Common/AgencyBadge';
import { minWidth, width } from '@mui/system';
import NameTooltip from 'component/Common/NameTooltip';

export default function Requestdeposit(props) {
  const {
    row,
    selectedrowbuyername,
    getListInfo,
    requestdeposit,
    setRequestdeposit,
    address,
    setReqDepositOpen,
    endPropertyPopupFromNominateWinner,
    setEndPropertyPopupFromNominateWinner,
    depositRes,
    profileDetails,
    fromFlow,
    exchangeFlow,
    fromOutstndingBanner,
    fromWinnerPendingBanner,
    AgentGroupCall,
    BuyerId,
    manageOfferClick,
    setSelectedrow,
    fromTable,
    highestOfferBuyerId,
  } = props;

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches400 = useMediaQuery(theme.breakpoints.down(600));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches750 = useMediaQuery(theme.breakpoints.down(750));
  const matches800 = useMediaQuery(theme.breakpoints.down(850));
  const flexStyle = { display: 'flex', alignItems: 'center', gap: '15px' };
  const reqStyle = {
    fontFamily: 'poppins',
    color: '#666666',
    whiteSpace: matches400 ? 'nowrap' : 'wrap',
    fontSize: matches750 ? '14px' : '16px',
    width: '30%',
  };
  const params = useParams();

  const CopyIcon = () => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_36034_154632)">
          <path
            d="M7 6V3C7 2.73478 7.10536 2.48043 7.29289 2.29289C7.48043 2.10536 7.73478 2 8 2H20C20.2652 2 20.5196 2.10536 20.7071 2.29289C20.8946 2.48043 21 2.73478 21 3V17C21 17.2652 20.8946 17.5196 20.7071 17.7071C20.5196 17.8946 20.2652 18 20 18H17V21C17 21.552 16.55 22 15.993 22H4.007C3.87513 22.0008 3.7444 21.9755 3.62232 21.9256C3.50025 21.8757 3.38923 21.8022 3.29566 21.7093C3.20208 21.6164 3.12779 21.5059 3.07705 21.3841C3.02632 21.2624 3.00013 21.1319 3 21L3.003 7C3.003 6.448 3.453 6 4.01 6H7ZM5.003 8L5 20H15V8H5.003ZM9 6H17V16H19V4H9V6Z"
            fill="#C4C4C4"
          />
        </g>
        <defs>
          <clipPath id="clip0_36034_154632">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  };

  const {
    setWinerPublishdMoveToEnded,
    setDisplayExchange,
    setOpenManageOfferFromVendorStatus,
  } = useContext(PropertyContext);

  const [formattedTotalAmount, setFormattedTotalAmount] = useState('');
  const [accnocopied, setAccNoCopied] = useState(false);
  const [percentDis, setPercentDis] = useState(false);
  const [amountDis, setAmountDis] = useState(false);
  const [bsbcopied, setBsbCopied] = useState(false);
  const [contractAprove, setContractAprove] = useState(false);
  const [depositDue, setDepositDue] = useState();
  const [depositAmount, setDepositAmount] = useState();
  const [accountcopied, setAccountCopied] = useState(false);
  const [depositSettlement, setDepositSettlement] = useState();
  const [FromOgDate, setFromOgDate] = useState();
  const [depositSettleErr, setDepositSettleErr] = useState(false);
  const [depositPercent, setDepositPercent] = useState();
  const [depositAmtErr, setDepositAmtErr] = useState(false);
  const [amount, setAmount] = useState(0);
  const [depositDueErr, setDepositDueErr] = useState(false);
  const [contractAppLoader, setContractAppLoader] = useState(false);
  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);

  const isFormValid =
    depositAmount && !depositAmtErr && !!depositDue && !!depositSettlement;

  const propertyId = profileDetails?.PropertyDetails?.property?.propertyId;

  const stageTwo = profileDetails?.PropertyDetails?.stage === 'ST2';
  const today = dayjs().tz('Australia/Sydney').startOf('day');

  const [depositDetailsData, setDepositDetailsData] = useState({});
  const [depositDetailsLoader, setDepositDetailsLoader] = useState(false);

  const paramsPropertyId = params?.dashboardId;

  const selectedrowbuyerid = highestOfferBuyerId
    ? highestOfferBuyerId
    : fromOutstndingBanner
    ? BuyerId
    : row?.buyerDetails?.user?.userId;

  const input = {
    propertyId: propertyId || paramsPropertyId,
    buyerId: selectedrowbuyerid,
  };
  const [agencyName, setAgencyName] = useState('');
  const getDetailsData = async () => {
    setDepositDetailsLoader(true);
    try {
      const res = await getApiCall(DEPOSIT_MANAGER_DETAILS, input);

      if (res?.status == 200) {
        setDepositDetailsData(res?.data);
        setAgencyName(res?.data?.depositDetails?.agentAgencyName);
      }
    } catch (error) {
      console.error('Error fetching deposit table data:', error);
    } finally {
      setDepositDetailsLoader(false);
    }
  };

  useEffect(() => {
    if (requestdeposit) {
      getDetailsData();
    }
  }, [requestdeposit]);

  const {
    buyerName,
    buyerSurName,
    alreadyHeldFormatted,
    receivedDate,
    alreadyHeldRequestFormatted,
    alreadyHeldTransferFormatted,
    settlementDays,
    depositPercentage,
    formattedOfferPrice,
    alreadyHeldRequested,
    offerPrice,
    requestedAmount,
  } = depositDetailsData?.depositDetails || {};

  const buyerFullName = `${buyerName ?? ''} ${buyerSurName ?? ''}`.trim();

  const BuyerName = fromOutstndingBanner ? buyerFullName : selectedrowbuyername;

  const isOfferPriceMatched = Number(offerPrice) === Number(requestedAmount);

  const colseContractAprove = () => {
    if (endPropertyPopupFromNominateWinner) {
      setWinerPublishdMoveToEnded(true);
    }
    if (fromTable) {
      setSelectedrow(false);
    }
    setContractAprove(false);
    setRequestdeposit(false);
    setReqDepositOpen(false);
    setDepositAmtErr(false);
    setDepositDueErr(false);
    setDepositSettleErr(false);
    setDepositAmount('');
    setDepositPercent('');
    setAmount(0);
    setDepositDue(null);
    setFromOgDate(null);
    setDepositSettlement('');
  };

  const reqdeposit = () => {
    if (!fromFlow) {
      setContractAppLoader(true);
    }
    const inputData = {
      buyerId: selectedrowbuyerid,
      propertyId: paramsPropertyId,
      isConfirmDeposit: depositRes == 'Processing' ? 1 : 0,
      depositAmount: depositRes == 'Processing' ? 0 : depositAmount,
      amountIn: depositRes == 'Processing' ? null : Number(depositPercent),
      settlementDays: depositRes == 'Processing' ? 0 : depositSettlement,
      dueDate: depositRes == 'Processing' ? null : depositDue,
      trustAccName:
        depositRes == 'Processing' ? null : 'AJ Real Estate Trust Account',
      bsb: depositRes == 'Processing' ? null : '0191928',
      accNo: depositRes == 'Processing' ? null : '019021928',
      depositType: 'EFT',
    };
    postApiCall(REQUEST_DEPOSIT, inputData)
      .then((res) => {
        if (res?.data?.status == '1') {
          if (fromOutstndingBanner) {
            AgentGroupCall();
          }
          if (fromFlow) {
            setRequestdeposit(false);
          }
          if (!fromFlow) {
            moxoapis(res);
            getListInfo();
            setContractAppLoader(false);
            setReqDepositOpen(false);
            setDepositAmount('');
            setDepositPercent('');
            setFormattedTotalAmount('');
            setAmount(0);
            setDepositDue(null);
            setFromOgDate(null);
            setDepositSettlement('');
            setRequestdeposit(false);
          }
          Swal.fire({
            title: res?.data?.heading
              ? res?.data?.heading
              : depositRes == 'Processing'
              ? 'Confirmed'
              : 'Requested',
            html:
              depositRes == 'Processing'
                ? `The deposit payment has now been confirmed as received. <b style="font-family: Poppins; font-weight: 550; color:#666666;">${BuyerName}</b> has been notified.`
                : `The deposit payment has been requested <br /> from <b style="font-family: Poppins; font-weight: 550; color:#666666;">${BuyerName}</b>.`,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
              if (endPropertyPopupFromNominateWinner && !fromFlow) {
                setTimeout(() => {
                  setDisplayExchange(true);
                }, 2000);
                setEndPropertyPopupFromNominateWinner(false);
              }
            } else if (result.isDenied) {
              return;
            }
          });
        } else {
          if (!fromFlow) {
            setContractAppLoader(false);
            setReqDepositOpen(false);
            setDepositPercent('');
            setAmount(0);
            setFromOgDate(null);
            setDepositSettlement('');
            setFormattedTotalAmount('');
          }
          Swal.fire({
            title: res?.data?.heading ? res?.data?.heading : 'Error',
            text: res?.data?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
              if (endPropertyPopupFromNominateWinner && !fromFlow) {
                setWinerPublishdMoveToEnded(true);
                setEndPropertyPopupFromNominateWinner(false);
              }
            } else if (result.isDenied) {
              return;
            }
          });
        }
      })
      .catch(() => {
        if (!fromFlow) {
          setContractAppLoader(false);
        }
      });
  };

  const reqdepositvalidate = () => {
    if (depositAmtErr) return;
    if (!depositDue) {
      setDepositDueErr(true);
    } else {
      setDepositDueErr(false);
    }
    if (!depositSettlement) {
      setDepositSettleErr(true);
    } else {
      setDepositSettleErr(false);
    }
    if (depositAmount && depositDue && depositSettlement) {
      reqdeposit();
    }
  };

  const handleBsbCopy = () => {
    navigator.clipboard.writeText('019 1928');
    setBsbCopied(true);

    setTimeout(() => {
      setBsbCopied(false);
    }, 2000);
  };

  const handleAccountCopy = () => {
    navigator.clipboard.writeText('AJ Real Estate Trust Account');
    setAccountCopied(true);

    setTimeout(() => {
      setAccountCopied(false);
    }, 2000);
  };

  const sanitizeAmount = (value) => {
    let cleanedValue = value?.replace(/[$,%\s]/g, '');
    return Number(cleanedValue);
  };

  let offerPriceValue = sanitizeAmount(
    fromOutstndingBanner
      ? formattedOfferPrice
      : row?.buyerDetails?.buyerOffer?.offerPrice
  );

  useEffect(() => {
    setDepositSettlement(settlementDays);
    setDepositPercent(depositPercentage);
  }, [requestdeposit, settlementDays, depositPercentage]);
  const depositInputRef = useRef();

  const handleDepositPercentChange = useCallback(
    (e) => {
      let value = e.target.value.replace('%', '').replace(/^0+(?=\d)/, '');

      if (!/^\d*$/.test(value)) return;

      const percentValue = Number(value);
      if (percentValue > 100) return;

      const paid =
        Number(
          fromOutstndingBanner
            ? alreadyHeldRequested
            : row?.requestedDepositAmount
        ) || 0;

      const expectedDeposit = (percentValue / 100) * offerPriceValue;
      const totalPossible = offerPriceValue - paid;

      if (expectedDeposit > totalPossible) {
        setDepositAmtErr(true);
        return;
      }

      const isValid = value && percentValue >= 0;

      setDepositAmtErr(false);
      setDepositAmount(isValid ? expectedDeposit : 0);
      setFormattedTotalAmount(
        isValid ? expectedDeposit.toLocaleString('en-US') : ''
      );
      setDepositPercent(value);
    },
    [
      fromOutstndingBanner,
      alreadyHeldRequested,
      row?.requestedDepositAmount,
      offerPriceValue,
    ]
  );

  const handleDepositAmountChange = useCallback(
    (e) => {
      const input = e.target;
      const raw = input.value;
      const cursorPos = input.selectionStart;

      const newValue = raw.replace(/[^0-9.]/g, '');
      const depositAmount = parseFloat(newValue) || 0;

      const paid = Number(alreadyHeldRequested) || 0;
      const remainingAmount = offerPriceValue - paid;

      if (depositAmount > remainingAmount) {
        setDepositAmtErr(true);
        return;
      } else {
        setDepositAmtErr(false);
      }

      const formattedAmount = depositAmount.toLocaleString('en-US', {
        maximumFractionDigits: 0,
      });

      setFormattedTotalAmount(formattedAmount);
      setDepositAmount(depositAmount);

      // % calculation
      if (offerPriceValue > 0) {
        const calculatedPercent = (
          (depositAmount / offerPriceValue) *
          100
        ).toFixed(0);
        setDepositPercent(calculatedPercent);
      } else {
        setDepositPercent('0');
      }

      // Fix cursor position
      requestAnimationFrame(() => {
        const digitsBeforeCursor = raw
          .slice(0, cursorPos)
          .replace(/\D/g, '').length;

        let newCursor = 0;
        let digitSeen = 0;

        for (let i = 0; i < formattedAmount.length; i++) {
          if (/\d/.test(formattedAmount[i])) digitSeen++;
          newCursor++;
          if (digitSeen === digitsBeforeCursor) break;
        }

        depositInputRef.current?.setSelectionRange(newCursor, newCursor);
      });
    },
    [alreadyHeldRequested, offerPriceValue]
  );

  const calculateDepositFromPercentage = useCallback(
    (percent, totalAmount) => {
      if (!percent || !totalAmount || totalAmount <= 0) return;

      const targetDeposit = (totalAmount * percent) / 100;

      const remainingAmount = Math.max(targetDeposit, 0);

      const paid = Number(alreadyHeldRequested) || 0;
      const totalPossible = offerPriceValue - paid;

      if (remainingAmount > totalPossible) {
        setDepositAmtErr(true);
        setDepositAmount(0);
        setFormattedTotalAmount('0');
        return;
      }

      setDepositAmtErr(false);
      setDepositAmount(remainingAmount);
      setFormattedTotalAmount(remainingAmount.toLocaleString('en-US'));
    },
    [alreadyHeldRequested, offerPriceValue]
  );

  useEffect(() => {
    if (!offerPriceValue) {
      setDepositPercent('');
      setDepositAmount(0);
      setFormattedTotalAmount('');
      return;
    }

    const defaultPercent = depositPercentage;

    setDepositPercent(defaultPercent);

    calculateDepositFromPercentage(defaultPercent, offerPriceValue);

    setDepositAmtErr(false);
  }, [
    depositPercentage,
    alreadyHeldRequested,
    offerPriceValue,
    calculateDepositFromPercentage,
  ]);

  const [open, setOpen] = useState(false);
  const [toggleState, setToggleState] = useState(true);

  const handleToggleState = () => {
    setToggleState((prev) => !prev);
  };
  const handleIconClick = () => {
    setOpen(true);
  };

  const moxoapis = (res) => {
    if (isNotEmptyArray(res?.data?.dataForDepositBuyerAck))
      Moxoseparationinlisting(
        'dataForDepositBuyerAck',
        res?.data?.dataForDepositBuyerAck
      ); //1
    if (isNotEmptyArray(res?.data?.dataForVendorAck))
      Moxoseparationinlisting('dataForVendorAck', res?.data?.dataForVendorAck); //2
  };
  useEffect(() => {
    if (depositPercent) {
      setAmountDis(true);
    } else {
      setAmountDis(false);
    }
  }, [depositPercent]);

  useEffect(() => {
    if (amount) {
      setPercentDis(true);
    } else {
      setPercentDis(false);
    }
  }, [amount]);

  const handleAccNoCopy = () => {
    navigator.clipboard.writeText('0190 21928');
    setAccNoCopied(true);

    setTimeout(() => {
      setAccNoCopied(false);
    }, 2000);
  };

  useEffect(() => {
    if (contractAppLoader) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [contractAppLoader]);

  return (
    <Dialog
      open={requestdeposit}
      PaperProps={{
        sx: {
          borderRadius: '5px',
          minWidth: matches800 ? '95%' : '800px',
          boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
          paddingBottom: matches700 && '40px',
        },
      }}
    >
      <Grid container height={'100%'}>
        <Grid container xs={12} sx={{ padding: '30px' }}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {'   '}
              {address}
              &nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              {depositRes == 'Processing'
                ? 'Confirm Deposit Received'
                : 'Request Deposit Payment'}
            </Typography>
          </Grid>
          <Grid item textAlign={'left'} paddingTop={'10px'}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                width: 'auto',
                color: '#666666',
              }}
            >
              {depositRes == 'Processing' ? (
                <>
                  {' '}
                  You are confirming that buyer{' '}
                  <b
                    style={{
                      fontFamily: 'Poppins',
                      fontWeight: 550,
                      color: '#666666',
                    }}
                  >
                    {BuyerName}
                  </b>{' '}
                  has processed the deposit payment and cleared funds have been
                  received. <br />
                  The buyer will be notified that their payment has been
                  received and the exchange process is now complete.{' '}
                </>
              ) : (
                <>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: 16,
                      color: '#444',
                      lineHeight: 1.6,
                    }}
                  >
                    You are about to send a request to buyer{' '}
                    <Box
                      component="span"
                      sx={{
                        fontWeight: 600,
                        color: '#333',
                      }}
                    >
                      {BuyerName}
                    </Box>{' '}
                    to make a deposit payment for{' '}
                    <Box
                      component="span"
                      sx={{
                        fontWeight: 600,
                        color: '#333',
                      }}
                    >
                      {address}
                    </Box>
                    .
                  </Typography>
                </>
              )}
            </Typography>
          </Grid>
        </Grid>

        {depositRes != 'Processing' && (
          <Box sx={{ borderTop: '1px solid lightgrey', width: '100%' }}></Box>
        )}

        <Grid
          container
          direction="column"
          sx={{
            padding: '38px 0 0 31px',
          }}
          rowGap={3}
        >
          {/* First Row - Two Items in Row */}
          <Grid item>
            <Stack direction="row" spacing={4} alignItems="center">
              <Stack
                display={!alreadyHeldFormatted && 'none'}
                direction="row"
                spacing={10}
                alignItems="center"
              >
                <Typography sx={{ ...reqStyle, whiteSpace: 'nowrap' }}>
                  Already Held:
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    color: '#000000',
                    fontSize: '16px',
                  }}
                >
                  {alreadyHeldFormatted ?? '-'}
                </Typography>
              </Stack>

              <Stack
                display={!receivedDate && 'none'}
                direction="row"
                spacing={!receivedDate ? 9 : 6}
                alignItems="center"
              >
                <Typography sx={{ ...reqStyle, whiteSpace: 'nowrap' }}>
                  Received Date:
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    color: '#000000',
                    fontSize: '16px',
                  }}
                >
                  {formatDepositDate(receivedDate) || '-'}
                </Typography>
              </Stack>
            </Stack>
          </Grid>

          {/* Second Row */}
          <Grid item display={!alreadyHeldRequestFormatted && 'none'}>
            <Stack direction="row" spacing={3} alignItems="center">
              <Typography sx={{ ...reqStyle, whiteSpace: 'nowrap' }}>
                Already Requested:
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  color: '#000000',
                  fontSize: '16px',
                }}
              >
                {alreadyHeldRequestFormatted ?? '-'}
              </Typography>
            </Stack>
          </Grid>

          {/* Third Row */}
          <Grid item display={!alreadyHeldTransferFormatted && 'none'}>
            <Stack direction="row" spacing={3} alignItems="center">
              <Typography sx={{ ...reqStyle, whiteSpace: 'nowrap' }}>
                Already Transferred:
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  color: '#000000',
                  fontSize: '16px',
                }}
              >
                {alreadyHeldTransferFormatted ?? '-'}
              </Typography>
            </Stack>
          </Grid>
        </Grid>

        {depositRes != 'Processing' && (
          <Grid
            container
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: '20px',
              margin: '30px',
            }}
          >
            <Grid xs={12}>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontSize: '24px',
                  fontWeight: 400,
                }}
              >
                Deposit Details
              </Typography>
            </Grid>
            <Grid
              xs={12}
              sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                minWidth: 0,
                gap: '12px',
              }}
            >
              <Typography
                sx={{
                  ...reqStyle,
                  flexShrink: 0,
                  whiteSpace: 'nowrap',
                }}
              >
                Buyer Name:
              </Typography>

              <Box
                sx={{
                  flex: '0 1 auto',
                  minWidth: 0,
                  maxWidth: 'calc(100% - 160px)',
                  overflow: 'hidden',
                }}
              >
                <NameTooltip name={BuyerName || ''}>
                  <Typography
                    component="span"
                    sx={{
                      fontFamily: 'Poppins',
                      color: '#000000',
                      fontSize: '16px',
                      display: 'block',
                      width: '100%',
                      minWidth: 0,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      cursor: 'pointer',
                    }}
                  >
                    {BuyerName}
                  </Typography>
                </NameTooltip>
              </Box>

              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  color: '#2488d5',
                  fontSize: '16px',
                  flexShrink: 0,
                  whiteSpace: 'nowrap',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  if (
                    fromFlow ||
                    exchangeFlow ||
                    fromOutstndingBanner ||
                    fromWinnerPendingBanner
                  ) {
                    setOpenManageOfferFromVendorStatus({
                      open: true,
                      buyerId: selectedrowbuyerid,
                    });
                  } else {
                    manageOfferClick();
                  }
                }}
              >
                View current offer
              </Typography>
            </Grid>
            <Grid xs={12} sx={flexStyle}>
              <Typography sx={reqStyle}>Offer Amount:</Typography>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  color: '#000000',
                  fontSize: '16px',
                  marginLeft: matches400 && '30px',
                }}
              >
                {formattedOfferPrice ||
                  row?.buyerDetails?.buyerOffer?.offerPrice}
              </Typography>
            </Grid>
            <Grid
              xs={12}
              sx={flexStyle}
              style={{ flexWrap: matches400 ? 'wrap' : 'nowrap' }}
            >
              <Typography sx={reqStyle}>Deposit Amount:</Typography>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: {
                    xs: '100%', // Full width on mobile
                    sm: '80%',
                    md: '65%',
                  },
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: {
                      xs: 'column', // Stack inputs vertically on mobile
                      sm: 'row',
                    },
                    alignItems: {
                      xs: 'flex-start',
                      sm: 'center',
                    },
                    gap: '15px',
                    flexWrap: 'wrap',
                  }}
                >
                  <TextField
                    variant="outlined"
                    error={depositAmtErr}
                    disabled={isOfferPriceMatched || contractAppLoader}
                    inputProps={{
                      maxLength: 3,
                      style: { fontFamily: 'Poppins', padding: 9 },
                    }}
                    style={{
                      opacity: percentDis && 0.5,
                      pointerEvents: percentDis && 'none',
                    }}
                    value={depositPercent}
                    onChange={handleDepositPercentChange}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          sx={{
                            justifyContent: { xs: 'center', sm: 'flex-end' },
                          }}
                        >
                          <Typography
                            sx={{
                              background: 'transparent',
                              display: 'flex',
                              alignItems: 'center',
                              fontSize: { xs: '12px', sm: '14px', md: '16px' },
                              fontWeight: 600,
                              fontFamily: 'Poppins',
                            }}
                            disabled={contractAppLoader}
                          >
                            %
                          </Typography>
                        </InputAdornment>
                      ),
                      sx: {
                        fontSize: {
                          xs: '14px',
                          sm: '16px',
                          md: '20px',
                        },
                        textAlign: 'center',
                        fontFamily: 'Poppins',
                        fontWeight: 400,
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: {
                          xs: '14px',
                          sm: '16px',
                          md: '20px',
                        },
                        textAlign: 'center',
                        fontFamily: 'Poppins',
                        fontWeight: 400,
                      },
                    }}
                    sx={{
                      width: {
                        xs: '100%',
                        sm: '85px',
                      },
                      height: '50px',
                      display: 'flex',
                      alignItems: 'left',
                      justifyContent: 'center',
                      '& .MuiOutlinedInput-input': {
                        textAlign: 'center',
                        fontFamily: 'Poppins',
                        fontWeight: 400,
                      },
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '5px',
                      },
                    }}
                  />

                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: {
                        xs: '16px',
                        sm: '18px',
                        md: '20px',
                      },
                      color: 'lightgrey',
                      textAlign: 'center',
                      width: {
                        xs: '100%',
                        sm: 'auto',
                      },
                    }}
                  >
                    OR
                  </Typography>

                  <TextField
                    variant="outlined"
                    error={depositAmtErr}
                    value={formattedTotalAmount}
                    inputProps={{
                      maxLength: 10,
                      style: { fontFamily: 'Poppins' },
                      pattern: '[0-9]*',
                    }}
                    disabled={isOfferPriceMatched || contractAppLoader}
                    onChange={handleDepositAmountChange}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment
                          position="start"
                          sx={{
                            minWidth: 'auto',
                            justifyContent: { xs: 'center', sm: 'flex-start' }, // Center for mobile, left for web
                            width: { xs: '30px', sm: 'auto' }, // Reduce width only in mobile
                          }}
                        >
                          <Typography
                            sx={{
                              background: 'transparent',
                              padding: { xs: '0 2px', sm: '0 10px' }, // Reduce padding in mobile only
                              display: 'flex',
                              alignItems: 'center',
                              fontSize: { xs: '16px', sm: '18px', md: '20px' },
                              fontWeight: 600,
                              fontFamily: 'Poppins',
                              marginRight: matchessm ? -25 : 0,
                            }}
                          >
                            $
                          </Typography>
                        </InputAdornment>
                      ),
                      sx: {
                        fontSize: { xs: '14px', sm: '16px', md: '20px' },
                        height: '50px',
                        fontWeight: 400,
                        fontFamily: 'Poppins',
                        '& .MuiInputBase-input': {
                          paddingLeft: { xs: '2px', sm: 'inherit' }, // Reduce padding in mobile only
                          textAlign: { xs: 'center', sm: 'left' }, // Center text in mobile, left in web
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: { xs: '14px', sm: '16px', md: '20px' },
                        fontWeight: 400,
                        fontFamily: 'Poppins',
                      },
                    }}
                    sx={{
                      width: { xs: '100%', sm: '80%' },
                      '& .MuiInputBase-input::placeholder': {
                        fontSize: { xs: '14px', sm: '16px', md: '20px' },
                        fontWeight: 400,
                        fontFamily: 'Poppins',
                      },
                    }}
                  />
                </Box>

                <span
                  style={{
                    visibility: depositAmtErr ? 'visible' : 'hidden',
                    color: 'red',
                    fontFamily: 'Poppins',
                    fontSize: '14px',
                    marginTop: '8px',
                  }}
                >
                  Enter the valid percentage or amount
                </span>
              </Box>
            </Grid>
            <Grid
              xs={12}
              sx={flexStyle}
              style={{ flexWrap: matches400 && 'wrap' }}
            >
              <Typography sx={reqStyle}>Deposit Due:</Typography>
              <Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer
                    components={['DatePicker']}
                    sx={{ overflow: 'hidden' }}
                  >
                    <DatePicker
                      disableScrollLock
                      disabled={contractAppLoader}
                      open={open}
                      onOpen={() => setOpen(true)}
                      onClose={() => setOpen(false)}
                      value={FromOgDate}
                      onChange={(newValue) => {
                        setFromOgDate(newValue);
                        const backendDate = newValue?.format('YYYY-MM-DD');
                        setDepositDue(backendDate);
                      }}
                      minDate={today}
                      maxDate={stageTwo ? today : undefined}
                      format="DD-MM-YYYY"
                      sx={{
                        '& .MuiInputBase-root': {
                          height: '50px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: depositDueErr && '0.5px solid red',
                        },
                        '& .MuiPickersPopper-root': {
                          overflow: 'hidden', // Fix scrollbar issue
                        },
                      }}
                      slotProps={{
                        textField: {
                          InputProps: {
                            startAdornment: (
                              <InputAdornment
                                position="start"
                                onClick={handleIconClick}
                                style={{ cursor: 'pointer' }}
                              >
                                <Calendarimg />
                              </InputAdornment>
                            ),
                            sx: {
                              fontSize: matches750 ? '14px' : '18px',
                              fontFamily: 'Poppins',
                            },
                          },
                          inputProps: {
                            onClick: () => setOpen(true), // Open picker when input field is clicked
                            sx: {
                              '::placeholder': {
                                fontSize: matches750 ? '14px' : '18px',
                                fontFamily: 'Poppins',
                              },
                            },
                          },
                        },
                        openPickerButton: {
                          sx: { display: 'none' }, // Hide default open button
                        },
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
                <span
                  style={{
                    visibility: depositDueErr ? 'visible' : 'hidden',
                    color: 'red',
                    fontFamily: 'poppins',
                    fontSize: '14px',
                  }}
                >
                  Select Due Date
                </span>
              </Box>
            </Grid>
            <Grid
              xs={12}
              sx={flexStyle}
              style={{ flexWrap: matches400 && 'wrap' }}
            >
              <Typography sx={reqStyle}>Proposed Settlement:</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                <Box>
                  <TextField
                    type="number"
                    variant="outlined"
                    inputProps={{
                      maxLength: 3,
                      style: { fontFamily: 'Poppins' },
                      inputMode: 'numeric',
                      min: 0,
                    }}
                    value={depositSettlement}
                    disabled={contractAppLoader}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.length <= 3) {
                        setDepositSettlement(value);
                        setDepositSettleErr(false);
                      }
                    }}
                    onKeyDown={(e) => {
                      // Prevent invalid characters: e, E, +, -, .
                      if (['e', 'E', '+', '-', '.'].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    InputProps={{
                      sx: {
                        fontSize: matches750 ? '14px' : '20px',
                        textAlign: 'center',
                        '&::placeholder': {
                          textAlign: 'center',
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: matches750 ? '14px' : '20px',
                        textAlign: 'center',
                      },
                    }}
                    error={depositSettleErr}
                    sx={{
                      width: '80px',
                      height: '50px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      '& .MuiOutlinedInput-input': {
                        textAlign: 'center',
                        padding: '10px 14px',
                        MozAppearance: 'textfield',
                      },
                      '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
                        {
                          WebkitAppearance: 'none',
                          margin: 0,
                        },
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '5px',
                      },
                    }}
                  />
                  <span
                    style={{
                      visibility: depositSettleErr ? 'visible' : 'hidden',
                      color: 'red',
                      fontFamily: 'poppins',
                      fontSize: '14px',
                    }}
                  >
                    Enter Days
                  </span>
                </Box>
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontSize: matches800 ? '12px' : '16px',
                    marginBottom: matches500 && '39px',
                  }}
                >
                  {Number(depositSettlement) === 1 ? 'day' : 'days'} after the
                  exchanged contract date.
                </Typography>
              </Box>
            </Grid>
            <Grid
              xs={12}
              container
              direction={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'flex-start', sm: 'center' }}
              justifyContent="space-between"
              sx={{
                gap: { xs: '10px', sm: '5px' },
                paddingX: { xs: '10px', sm: '0px' },
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontSize: { xs: '24px', sm: '20px', md: '24px' },
                  fontWeight: 400,
                  color: '#112347',
                }}
              >
                EFT Payment Details
              </Typography>

              <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                sx={{
                  pr: { xs: '0px', sm: '50px' },
                  flexWrap: 'wrap',
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: { xs: '14px', sm: '12px' },
                    color: toggleState ? '#112347' : '#9C9C9C',
                  }}
                >
                  Agency Trust
                </Typography>

                <Box
                  onClick={handleToggleState}
                  sx={{
                    width: '50px',
                    height: '25px',
                    background:
                      'linear-gradient(140.46deg, #6C2AD2 -27.13%, #77CFFE 121.57%)',
                    borderRadius: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: toggleState ? 'flex-start' : 'flex-end',
                    padding: '3px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    boxShadow: 'inset 0px 0px 4px rgba(0,0,0,0.3)',
                  }}
                >
                  <Box
                    sx={{
                      width: '18px',
                      height: '18px',
                      backgroundColor: 'white',
                      borderRadius: '50%',
                      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
                      transition: 'all 0.3s ease',
                    }}
                  />
                </Box>

                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: { xs: '14px', sm: '12px' },
                    color: toggleState ? '#9C9C9C' : '#112347',
                  }}
                >
                  Legal Trust
                </Typography>
              </Stack>
            </Grid>
            <Grid container spacing={2} sx={flexStyle}>
              <Grid
                item
                xs={12}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: matches400 ? 'wrap' : 'nowrap',
                }}
              >
                <Typography
                  sx={{
                    ...reqStyle,
                    fontFamily: 'Poppins',
                    fontSize: '16px',
                    fontWeight: 400,
                    wordBreak: 'break-word',
                    whiteSpace: 'normal',
                    minWidth: '150px',
                  }}
                >
                  Deposit Holder
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flex: 1,
                    marginTop: matches400 ? 1 : 0,
                    marginLeft: '15px',
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: '16px',
                      fontWeight: 400,
                      color: '#000000',
                    }}
                  >
                    Ray White Bondi Beach
                  </Typography>
                  {agencyName && (
                    <Box>
                      <AgencyBadge name={agencyName} />
                    </Box>
                  )}
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: matches400 ? 'wrap' : 'nowrap',
                }}
              >
                <Typography
                  sx={{
                    ...reqStyle,
                    fontFamily: 'Poppins',
                    fontSize: '16px',
                    fontWeight: 400,
                    wordBreak: 'break-word',
                    whiteSpace: 'normal',
                    minWidth: '150px', // Adjust label width for consistent alignment
                  }}
                >
                  Trust Account Name:
                </Typography>
                <Box
                  sx={{
                    flex: 1,
                    marginTop: matches400 ? 1 : 0,
                    marginLeft: '15px',
                  }}
                >
                  <TextField
                    variant="outlined"
                    value="AJ Real Estate Trust Account"
                    InputLabelProps={{
                      sx: {
                        fontSize: '16px',
                        fontWeight: 400,
                        fontFamily: 'Poppins',
                      },
                    }}
                    sx={{
                      width: matches750 ? '100%' : '452px',
                      '& .MuiInputBase-input': {
                        fontSize: {
                          xs: '10px',
                          sm: '12px',
                          md: '16px',
                          lg: '16px',
                          xl: '16px',
                        },
                        fontWeight: 400,
                        fontFamily: 'Poppins',
                        cursor: 'default',
                      },
                      '& .MuiOutlinedInput-root': {
                        cursor: 'default',
                      },
                    }}
                  />
                  <Tooltip
                    title={accountcopied ? 'Copied to clipboard' : ''}
                    open={accountcopied}
                    arrow
                  >
                    <IconButton onClick={handleAccountCopy}>
                      <CopyIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: matches400 ? 'wrap' : 'nowrap',
                }}
              >
                <Typography
                  sx={{
                    ...reqStyle,
                    fontFamily: 'Poppins',
                    fontSize: '16px',
                    fontWeight: 400,
                    minWidth: '150px', // Adjust label width for consistent alignment
                  }}
                >
                  BSB:
                </Typography>
                <Box sx={{ flex: 1, marginLeft: '15px' }}>
                  <TextField
                    variant="outlined"
                    value="019 1928"
                    InputLabelProps={{
                      sx: {
                        fontSize: '20px',
                        fontWeight: 400,
                        fontFamily: 'Poppins',
                      },
                    }}
                    sx={{
                      width: matches750 ? '100%' : '452px',
                      '& .MuiInputBase-input': {
                        fontSize: {
                          xs: '10px',
                          sm: '12px',
                          md: '16px',
                          lg: '16px',
                          xl: '16px',
                        },
                        fontWeight: 400,
                        fontFamily: 'Poppins',
                        cursor: 'default',
                      },
                      '& .MuiOutlinedInput-root': {
                        cursor: 'default',
                      },
                    }}
                  />
                  <Tooltip
                    title={bsbcopied ? 'Copied to clipboard' : ''}
                    open={bsbcopied}
                    arrow
                  >
                    <IconButton onClick={handleBsbCopy}>
                      <CopyIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: matches400 ? 'wrap' : 'nowrap',
                }}
              >
                <Typography
                  sx={{
                    ...reqStyle,
                    fontFamily: 'Poppins',
                    fontSize: '16px',
                    fontWeight: 400,
                    minWidth: '150px', // Adjust label width for consistent alignment
                  }}
                >
                  Account No:
                </Typography>
                <Box sx={{ flex: 1, marginLeft: '15px' }}>
                  <TextField
                    variant="outlined"
                    value="0190 21928"
                    InputLabelProps={{
                      sx: {
                        fontSize: '20px',
                        fontWeight: 400,
                        fontFamily: 'Poppins',
                      },
                    }}
                    sx={{
                      width: matches750 ? '100%' : '452px',
                      '& .MuiInputBase-input': {
                        fontSize: {
                          xs: '10px',
                          sm: '12px',
                          md: '16px',
                          lg: '16px',
                          xl: '16px',
                        },
                        fontWeight: 400,
                        fontFamily: 'Poppins',
                        cursor: 'default',
                      },
                      '& .MuiOutlinedInput-root': {
                        cursor: 'default',
                      },
                    }}
                  />
                  <Tooltip
                    title={accnocopied ? 'Copied to clipboard' : ''}
                    open={accnocopied}
                    arrow
                  >
                    <IconButton onClick={handleAccNoCopy}>
                      <CopyIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        )}

        <Grid
          item
          container
          direction="row"
          sx={{ display: 'flex', alignItems: 'center' }}
          justifyContent={'flex-end'}
          gap={2}
          marginBottom={'30px'}
          marginRight={'30px'}
        >
          <Grid item>
            <Button
              disabled={contractAppLoader}
              variant="outlined"
              style={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                width: '100%',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '15px',
                color: '#666666',
                fontWeight: '400',
                fontFamily: 'Poppins',
                border: '1px solid rgba(17, 35, 71, 0.1)',
                borderRadius: '5px',
                textTransform: 'none',
              }}
              onClick={colseContractAprove}
            >
              Cancel
            </Button>
          </Grid>
          <Grid
            item
            sx={{ position: 'relative', display: 'flex', alignItems: 'center' }}
          >
            <Button
              disabled={contractAppLoader || !isFormValid}
              variant="outlined"
              onClick={
                depositRes == 'Processing' ? reqdeposit : reqdepositvalidate
              }
              style={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                width: '100%',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '15px',
                color: '#FFFFFF',
                fontWeight: '400',
                fontFamily: 'Poppins',
                background: !isFormValid ? '#9c9c9c' : '#4CA4D6',
                borderRadius: '5px',
                textTransform: 'none',
              }}
            >
              {depositRes == 'Processing' ? 'Confirm' : 'Submit'}
            </Button>
            {contractAppLoader && (
              <img
                alt="Logo"
                src={Loading}
                className="loaderImage"
                style={{ height: '40px', width: '40px' }}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
}
